/* Aurande motion effects
   1. Slow zoom on the hero photo
   2. Hero headline rises in word by word
   3. Gentle parallax on the hero photo (screens 750px and wider)
   4. Soft fade-up as sections scroll into view
   Turns itself off for visitors who ask their device to reduce motion,
   and inside the Shopify theme editor. */
(function () {
  var doc = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;
  if (reduce || design) {
    doc.classList.remove('aur-motion');
    return;
  }
  doc.classList.add('aur-motion');

  var EASE_MS = 1700;
  var REVEAL_SELECTOR = [
    '.title-wrapper-with-link',
    '.multicolumn-list__item',
    '.image-with-text__media',
    '.image-with-text__content > *',
    '.rich-text__blocks > *',
    '.accordion',
    '.banner__media',
    '.collage__item'
  ].join(',');

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function escapeHtml(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function heroEffects() {
    var slides = document.querySelectorAll('.slideshow__slide');
    var wide = window.matchMedia('(min-width: 750px)').matches;

    Array.prototype.forEach.call(slides, function (slide) {
      // 1. Slow zoom, started once the photo has actually loaded
      var img = slide.querySelector('.slideshow__media img');
      if (img) {
        var startZoom = function () { img.classList.add('aur-kb'); };
        if (img.complete && img.naturalWidth) startZoom();
        else {
          img.addEventListener('load', startZoom, { once: true });
          img.addEventListener('error', startZoom, { once: true });
        }
      }

      // 2. Headline rises in word by word (screen readers still get the full sentence)
      var heading = slide.querySelector('.banner__heading');
      if (heading && !heading.getAttribute('data-aur-split')) {
        var text = heading.textContent.trim();
        heading.setAttribute('data-aur-split', '1');
        heading.setAttribute('aria-label', text);
        heading.innerHTML = text.split(/\s+/).map(function (word, i) {
          return '<span class="aur-word" aria-hidden="true"><span style="--i:' + i + '">' + escapeHtml(word) + '</span></span>';
        }).join(' ');
      }
      slide.classList.add('aur-hero-go');

      // 3. Parallax: the photo scrolls a little slower than the page
      var media = slide.querySelector('.slideshow__media');
      if (img && media && wide) {
        var ticking = false;
        var update = function () {
          ticking = false;
          var rect = media.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > window.innerHeight) return;
          img.style.translate = '0 ' + Math.round(Math.max(0, -rect.top) * 0.25) + 'px';
        };
        window.addEventListener('scroll', function () {
          if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(update);
          }
        }, { passive: true });
        update();
      }
    });
  }

  function scrollReveal() {
    if (!('IntersectionObserver' in window)) return;
    var sections = document.querySelectorAll('#MainContent > .shopify-section');
    var targets = [];

    Array.prototype.forEach.call(sections, function (section) {
      // Leave the hero and the product buy box alone
      if (/__main/.test(section.id) || section.querySelector('slideshow-component')) return;
      var found = Array.prototype.slice.call(section.querySelectorAll(REVEAL_SELECTOR));
      found = found.filter(function (el) {
        return !found.some(function (other) { return other !== el && other.contains(el); });
      });
      found.forEach(function (el, i) {
        el.classList.add('aur-reveal');
        el.style.setProperty('--aur-delay', (Math.min(i, 5) * 0.09).toFixed(2) + 's');
        targets.push(el);
      });
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);
        el.classList.add('is-in');
        // Tidy up afterwards so the theme's own hover effects work normally
        window.setTimeout(function () {
          el.classList.remove('aur-reveal', 'is-in');
          el.style.removeProperty('--aur-delay');
        }, EASE_MS);
      });
    }, { rootMargin: '0px 0px -8% 0px' });

    targets.forEach(function (el) { observer.observe(el); });
  }

  onReady(function () {
    heroEffects();
    scrollReveal();
  });
})();
